import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import React, { useState } from "react";
import OverviewHeader from "./overview-header";
import OverviewList from "./overview-list";

const Component: React.FC = () => {
    const [inventoryView, setInventoryView] = useState<"overview" | "inventory-list">("overview");
    return (
        <div className="flex flex-col w-full items-start justify-start p-4">
            <Tabs value={inventoryView} onValueChange={(value) => setInventoryView(value as "overview" | "inventory-list")} className="w-full">
                <div className="flex flex-row items-center justify-between w-full">
                    <TabsList>
                        <TabsTrigger value="overview">Overview</TabsTrigger>
                        <TabsTrigger value="inventiry-list">Inventory List</TabsTrigger>
                    </TabsList>
                    <Button variant="secondary">View Master</Button>
                </div>
                <TabsContent value="overview" className="mt-4">
                    <OverviewHeader />
                    <OverviewList />
                </TabsContent>
            </Tabs>
        </div>
    );
}

export default Component